<template>
    <div class="bng-topbar-wrapper">
        <div class="bng-topbar-2">
            <div class="container">
                <nav id="navigation" class="navbar bng-topbar" role="navigation" aria-label="main navigation">
                    <div class="navbar-brand">
                        <a
                            @click="goHome"
                            class="topbar-logo-link">
                            <img v-if="logo" :src="logo" class="topbar-logo" />
                            <span v-else class="topbar-title">{{title}}</span>
                        </a>
                    </div>
                    <last-winnings v-if="theme == 'cashcasino' || theme == 'luckerhub'" quantityType="solo"/>
                    <div v-if="loaded" class="navbar-end">
                        <topbar-buttons-block/>
                        <topbar-language visabilityType = "icons"/>
                    </div>
                </nav>
            </div>
        </div>
        <last-winnings v-if="theme == 'cashcasino'" quantityType="solo"/>
        <div v-if="showBars" class="navbar-menu">
            <topbar-menu/>
        </div>
        <last-winnings v-if="theme == 'luckerhub'" quantityType="solo"/>
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

import TopbarMenu from './topbar-menu.vue';
import TopbarButtonsBlock from './topbar-buttons-block.vue';
import TopbarLanguage from './topbar-language.vue';
import LastWinnings from '../last-winnings/last-winnings.vue';

export default {
    name: 'topbar-2',
    components: { TopbarMenu, TopbarButtonsBlock, TopbarLanguage, LastWinnings },
    data() {
        return {
            isActiveMenu: false,
            loaded: false,
            isMobile: isMobile.phone || isMobile.tablet,
            logo: null,
            title: null,
            theme: null,
            logoRoute: '/'
        };
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        },
        showBars() {
            return this.isLoggedIn || !this.client.view.auth.authenticationHideBars;
        }
    },
    watch: {
        $route(to, from) {
            // hide menu on mobile devices after click on menu item
            this.isActiveMenu = false;
        },
        isActiveMenu() {
            this.callingEventMobileMenu();
        }
    },
    async created() {
        await Vue.state.client.ensure();
        let client = Vue.state.client.get();
        this.logo = this.isMobile ? (client.view.style.logoMobile || client.view.style.logo) : client.view.style.logo;
        this.title = client.view.general.alias;
        this.theme = (this.client && this.client.view && this.client.view.style.theme) || 'dark';
        this.loaded = true;
    },
    methods: {
        async goHome() {
            await Vue.router.teleport.home();
        },
        toggleMenu() {
            this.isActiveMenu = !this.isActiveMenu;
            this.callingEventMobileMenu();
        },
        callingEventMobileMenu() {
            this.$emit('changeOpeningMobileMenu', {
                'isOpen': this.isActiveMenu
            });
        }
    },
}
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/topbar/topbar-2.vue